// extracted by mini-css-extract-plugin
export default {"button_wrapper":"TestResultsButton_button_wrapper__weu0F","counter":"TestResultsButton_counter__SFG8g","shimmer":"TestResultsButton_shimmer__NJppT"};